import { ExternalLink, Calculator } from "lucide-react";

export default function IFTACalculator() {
  const url = process.env.REACT_APP_IFTA_CALCULATOR_URL || "";

  if (url) {
    return (
      <div className="space-y-4" data-testid="ifta-page">
        <div className="flex items-end justify-between">
          <div>
            <div className="hs-overline text-blue-700">FUEL TAX</div>
            <h1 className="font-display font-black text-4xl uppercase tracking-tighter mt-2">IFTA Calculator</h1>
          </div>
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className="hs-btn-secondary inline-flex items-center gap-2 text-xs"
            data-testid="ifta-open-new-tab"
          >
            <ExternalLink size={14} /> OPEN IN NEW TAB
          </a>
        </div>
        <div className="hs-card overflow-hidden">
          <iframe
            src={url}
            title="Crystal Logistics IFTA Calculator"
            className="w-full"
            style={{ height: "calc(100vh - 220px)", minHeight: 600, border: 0 }}
            data-testid="ifta-iframe"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="ifta-page">
      <div>
        <div className="hs-overline text-blue-700">FUEL TAX</div>
        <h1 className="font-display font-black text-4xl uppercase tracking-tighter mt-2">IFTA Calculator</h1>
      </div>
      <div className="hs-card p-10 max-w-2xl">
        <div className="flex items-start gap-4">
          <div className="p-3 bg-blue-50 border border-blue-200">
            <Calculator size={24} className="text-blue-700" />
          </div>
          <div className="flex-1">
            <h2 className="font-display font-bold text-2xl">Coming via Crystal Logistics tools</h2>
            <p className="text-sm text-slate-600 mt-3 leading-relaxed">
              Our dedicated IFTA calculator is being plugged in. In the meantime, your IFTA quarterly
              filings (Q1–Q4) are tracked under <span className="font-semibold">Filings</span>, and at
              year-end the previous quarters auto-archive and a new set opens for the next year.
            </p>
            <p className="text-xs text-slate-500 mt-4">
              Admin: paste your calculator URL into <code className="font-mono">REACT_APP_IFTA_CALCULATOR_URL</code> to embed it here.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
